import { getDevFlags } from "@utils/dev-flags";
import { useMemo } from "react";

/**
 * Get dev flags from localStorage
 * Ignore if not in development mode
 * @returns
 */
export const useDevFlags = () => {
  const devFlags = useMemo(() => {
    return getDevFlags();
  }, []);

  return devFlags ?? null;
};
